import { createAction, props } from '@ngrx/store';
import {
  SkyBasketItemQuoteDetails,
  SkyCreateQuoteResponse,
} from '@sky/util-models';

export const loadQuotes = createAction(
  '[Basket] Load quotes',
  props<{ applianceCode: string }>()
);

export const loadQuotesSuccess = createAction(
  '[Basket] Quotes loaded successfully',
  props<{ quoteApiResult: SkyCreateQuoteResponse }>()
);

export const loadQuotesFailure = createAction(
  '[Basket] Load quotes failed',
  props<{ error: Error }>()
);

export const selectQuote = createAction(
  '[Basket] Select quote',
  props<{ quote: SkyBasketItemQuoteDetails }>()
);
